import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop.jsx';
import Mudanza from './pages/Mudanza.jsx';

// Las citas ya se reservan en Barberfy: la web es una sola página de aviso
// y cualquier otra dirección (reservar, login, dashboard...) lleva a ella.
function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Mudanza />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
